import classNames from 'classnames';
import { DetailedHTMLProps, FC, ReactNode, ThHTMLAttributes } from 'react';
import { Column } from 'react-table';

import TableSortLabel from '../label/TableSortLabel';

export interface TableHeaderCellProps extends DetailedHTMLProps<ThHTMLAttributes<HTMLTableHeaderCellElement>, HTMLTableHeaderCellElement> {
  column: Column<Record<string, unknown>>;
  sortable?: boolean;
  className?: string;
  children?: ReactNode;
}

const TableHeaderCell: FC<TableHeaderCellProps> = ({ column, sortable = false, className, children, ...props }) => {
  const thClassName = classNames('table-header-cell', className);

  // Sort properties
  const { isSorted, isSortedDesc } = column as any;

  return (
    <th className={thClassName} {...props}>
      {sortable ? (
        <TableSortLabel isSorted={isSorted} isSortedDesc={isSortedDesc}>
          {children}
        </TableSortLabel>
      ) : (
        children
      )}
    </th>
  );
};

TableHeaderCell.displayName = 'TableHeaderCell';

export default TableHeaderCell;
